var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBabyCarrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "child_friendly_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8331",
    "data-name": "Path 8331",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8332",
    "data-name": "Path 8332",
    d: "M12.083,2V9.333h7.333A7.331,7.331,0,0,0,12.083,2Zm5.793,12.733a7.286,7.286,0,0,0,1.54-4.483H6.07L5.2,8.417H2V10.25H4.035S5.767,13.981,5.978,14.3a3.207,3.207,0,1,0,4.693,3.282h1.907a3.206,3.206,0,1,0,5.3-2.851ZM7.5,18.5a1.375,1.375,0,1,1,1.375-1.375A1.373,1.373,0,0,1,7.5,18.5Zm8.25,0a1.375,1.375,0,1,1,1.375-1.375A1.373,1.373,0,0,1,15.75,18.5Z",
    transform: "translate(-0.167 -0.167)",
    fill: "#f8f9ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyCarrier);
export default __webpack_public_path__ + "static/media/baby_carrier.c635206c6f0c1110be30a1c2478d8628.svg";
export { ForwardRef as ReactComponent };